import "./i18n";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Login from './pages/Login';
import Home from './pages/Home';
import ProtectedApp from './ProtectedApp';
import 'react-loading-skeleton/dist/skeleton.css';
import reportWebVitals from "./reportWebVitals";
import NewOrder from "./pages/EditOrder";
import MyOrders from "./pages/MyOrders";
import { MsalProvider, useMsal, useIsAuthenticated } from '@azure/msal-react';
import msalInstance from './helpers/authProvider';
import WrapperPage from "./components/WrapperPage/WrapperPage";
import EditOrder from "./pages/EditOrder";
import Users from "./pages/Users";
import UsersBackoffice from "./pages/UsersBackoffice";
import Customers from "./pages/Customers";
import Links from './pages/Links';
import Reports from "./pages/Reports";
import "react-datepicker/dist/react-datepicker.css";
import CustomersSurveyConfiguration from "./pages/CustomersSurveyConfiguration";
import Notifications from "./pages/Notifications";
import ManageNotifications from "./pages/ManageNotifications";
import CustomersSurveyReport from "./pages/CustomersSurveyReport";
import CallCenter from "./pages/CallCenter";
import CallCenterView from "./pages/CallCenterView";
import HolidaysConfiguration from "./pages/HolidaysConfiguration";
import BankingAccount from "./pages/BankingAccount";
import ManageBankingAccount from "./pages/ManageBankingAccount";
import CallCenterReport from "./pages/CallCenterReport";

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <WrapperPage activeRoute='home'>
        <Home />
      </WrapperPage>
    ),
  },
  {
    path: "/login",
    element: <Login />
  },
  {
    path: "/home",
    element: (
      <WrapperPage activeRoute='home'>
        <Home />
      </WrapperPage>
    )
  },
  {
    path: "/new-order",
    element: (
      <WrapperPage activeRoute='new-order'>
        <NewOrder />
      </WrapperPage>
    ),
  },
  {
    path: "/edit-order/:idGroup",
    element: (
      <WrapperPage activeRoute='edit-order'>
        <EditOrder />
      </WrapperPage>
    ),
  },
  {
    path: "/financial",
    element: (
      <WrapperPage activeRoute='financial'>
        <Home />
      </WrapperPage>
    ),
  },
  {
    path: "/user-customer",
    element: (
      <WrapperPage activeRoute='user-customer'>
        <Users />
      </WrapperPage>
    ),
  },
  {
    path: "/customers",
    element: (
      <WrapperPage activeRoute='customers'>
        <Customers />
      </WrapperPage>
    ),
  },
  // {
  //   path: "/user-backoffice",
  //    element: (
  //     <WrapperPage activeRoute='user-backoffice'>
  //       <UsersBackoffice />
  //     </WrapperPage>
  //   ),
  // },
  {
    path: "/links",
    element: (
      <WrapperPage activeRoute='links'>
        <Links />
      </WrapperPage>
    ),
  },
  {
    path: "/reports",
    element: (
      <WrapperPage activeRoute='reports'>
        <Reports />
      </WrapperPage>
    ),
  },
  {
    path: "/reports/orders",
    element: (
      <WrapperPage activeRoute='reports' activeSubRoute='orders'>
        <Reports />
      </WrapperPage>
    ),
  },
  {
    path: "/reports/customers-survey-report",
    element: (
      <WrapperPage activeRoute='reports' activeSubRoute='customers-survey-report'>
        <CustomersSurveyReport />
      </WrapperPage>
    ),
  },
  {
    path: "/reports/call-center-report",
    element: (
      <WrapperPage activeRoute='reports' activeSubRoute='call-center-report'>
        <CallCenterReport />
      </WrapperPage>
    ),
  },
  {
    path: "/configurations",
    element: (
      <WrapperPage activeRoute='configurations'>
      </WrapperPage>
    ),
  },
  {
    path: "/configurations/customers-survey-configuration",
    element: (
      <WrapperPage activeRoute='configurations' activeSubRoute='customers-survey-configuration'>
        <CustomersSurveyConfiguration />
      </WrapperPage>
    ),
  },
  {
    path: "/configurations/holidays-configuration",
    element: (
      <WrapperPage activeRoute='configurations' activeSubRoute='holidays-configuration'>
        <HolidaysConfiguration />
      </WrapperPage>
    ),
  },
  {
    path: "/call-center",
    element: (
      <WrapperPage activeRoute='call-center'>
        <CallCenter />
      </WrapperPage>
    ),
  },
  {
    path: "/call-center/view",
    element: (
      <WrapperPage activeRoute='call-center'>
        <CallCenterView />
      </WrapperPage>
    ),
  },
  {
    path: "/notifications",
    element: (
      <WrapperPage activeRoute='notifications'>
        <Notifications />
      </WrapperPage>
    ),
  },
  {
    path: "/notifications/manage-notification",
    element: (
      <WrapperPage activeRoute='notifications'>
        <ManageNotifications />
      </WrapperPage>
    ),
  },
  {
    path: "/notifications/manage-notification/:id",
    element: (
      <WrapperPage activeRoute='notifications'>
        <ManageNotifications />
      </WrapperPage>
    ),
  },
  {
    path: "/notifications/manage-notification",
    element: (
      <WrapperPage>
        <ManageNotifications />
      </WrapperPage>
    ),
  },
  {
    path: "/notifications/manage-notification/:id",
    element: (
      <WrapperPage>
        <ManageNotifications />
      </WrapperPage>
    ),
  },
{
  path: "/reports",
   element: (
     <WrapperPage activeRoute='reports'>
      <Reports />
    </WrapperPage>
  ),
},
{
  path: "/reports/orders",
   element: (
     <WrapperPage activeRoute='reports' activeSubRoute='orders'>
      <Reports />
    </WrapperPage>
  ),
},
{
  path: "/reports/customers-survey-report",
  element: (
    <WrapperPage activeRoute='reports' activeSubRoute='customers-survey-report'>
      <CustomersSurveyReport />
    </WrapperPage>
  ),
},
{
  path: "/customers-survey-configuration",
   element: (
     <WrapperPage activeRoute='customers-survey-configuration'>
      <CustomersSurveyConfiguration />
    </WrapperPage>
  ),
},
{
  path: "/banking-account",
   element: (
     <WrapperPage activeRoute='banking-account'>
      <BankingAccount />
    </WrapperPage>
  ),
},
{
  path: "/banking-account/manage-banking-account",
   element: (
     <WrapperPage>
      <ManageBankingAccount />
    </WrapperPage>
  ),
},
{
  path: "/banking-account/manage-banking-account/:id",
   element: (
     <WrapperPage>
      <ManageBankingAccount />
    </WrapperPage>
  ),
},
]);

const AppContent = () => {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  React.useEffect(() => {
    instance.handleRedirectPromise().then((response) => {
      if (response) {
        console.log("Login successful via redirect");
      }
    }).catch((error) => {
      console.error("Error handling redirect:", error);
    });
  }, [instance]);

  if (inProgress === "login" || inProgress === "acquireToken") {
    return <p>Authenticating...</p>;
  }

  if (isAuthenticated && accounts.length > 0) {
    const account = accounts[0];
    const logout = () => {
      instance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin
      });
    };
    
    return (
      <ProtectedApp logout={logout} account={account}>
        <RouterProvider router={router} />
      </ProtectedApp>
    );
  }

  return <Login />;
};

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <AppContent />
    </MsalProvider>
  </React.StrictMode>
);

reportWebVitals();

